import authService from "../../../auth/AuthService";
import {apiActionsDP} from "../../../middlewares/veritas-middleware/constants/ApiMiddlewareConstants";
import {Types, Detail} from "../constants/DataProviderActionConstants";

const loadAllDataProviders = (providers) => ({
    type: Types.LOAD_ALL_DATA_PROVIDERS,
    payload: providers,
});

const loadAllOrganizations = (providers) => ({
    type: Types.LOAD_ALL_DATA_PROVIDERS_FOR_LIST_PAGE,
    payload: providers,
});

const fetchAllDPsForListPage = ({authToken}) => ({
    type: apiActionsDP.GET_ALL_ORGANIZATIONS,
    payload: {authToken}
});

const fetchOneDP = (providerID, authToken) => ({
    type: apiActionsDP.GET,
    payload: {providerID, authToken}
});

const fetchOneDPSuccess = (providerDetail) => ({
    type: Detail.LOAD_PROVIDER_DETAIL,
    payload: {providerDetail},
});

const unmountDPDetail = () => ({
    type: Detail.CLEAR_DP_DETAIL_PAGE,
});

const setDPFilters = (filterOption, filterType) => ({
   type: Types.SET_DP_LIST_FILTER,
   payload: {filterOption, filterType}
});

const updateDPFilters = () => ({
    type: Types.FILTER_DATA_PROVIDERS
});

const toggleDeleteWarningDP = () => ({
    type: Detail.DELETE_DP_WARNING
});

const deleteDP = (dpID, authToken) => ({
    type: apiActionsDP.DELETE_CURRENT_DATA_PROVIDER,
    payload: {dpID, authToken},
});

const toggleSortDP = (sortKey) => ({
    type: Types.TOGGLE_DP_SORT,
    payload: sortKey
});

export function unmountDataProviderDetail() {
    return (dispatch) => {
        dispatch(unmountDPDetail());
    }
}

export function fetchOneDataProvider(providerID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchOneDP(providerID, authToken));
    }
}

export function fetchAllOrganizations() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchAllDPsForListPage({authToken}));
    }
}

export function getAllDPSuccess(providers) {
    return (dispatch) => {
        dispatch(loadAllDataProviders(providers))
    }
}

export function getAllOrganizationsSuccess(providers) {
    return (dispatch) => {
        dispatch(loadAllOrganizations(providers))
    }
}

export function fetchOneDataProviderSuccess(providerDetail) {
    return (dispatch) => {
        dispatch(fetchOneDPSuccess(providerDetail))
    }
}

export function setDPListFilters(filterOption, filterType) {
    return (dispatch) => {
        dispatch(setDPFilters(filterOption, filterType));
    }
}

export function updateDPListFilters() {
    return (dispatch) => {
        dispatch(updateDPFilters());
    }
}

const dpGlobalSearch = (value) => ({
    type: Types.DP_GLOBAL_SEARCH,
    payload: value
})

export function dpTableSearch(value) {
    return (dispatch) => {
        dispatch(dpGlobalSearch(value))
    }
}

export function toggleDeleteWarning() {
    return (dispatch) => {
        dispatch(toggleDeleteWarningDP());
    }
}

export function deleteDataProvider(dpID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteDP(dpID, authToken));
    }
}

export function toggleDPSort(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortDP(sortKey))
    }
}

const exports = {
    Types, 
    Detail,
}

export default exports;